import React, { Dispatch } from 'react';

import { useHistory } from 'react-router-dom';

import { Box } from '@waglabs/box-next';
import { Button } from '@waglabs/button-next';
import { Modal } from '@waglabs/seo-modals';
import { Typography } from '@waglabs/typography';

import {
  DataTestIds,
  ROUTE_LOGIN,
} from '../../../../../../../constants';
import { WithHistoryInjectedProps } from '../../../../../../../hocs';
import { WagKeyIllustrationIcon } from '../../../../../../../icons';

import { ConflictModalContent } from './ConflictModalContent';

export type LinkAccountsModalProps = {
  isConflictModalOpen: boolean;
  setIsConflictModalOpen: Dispatch<React.SetStateAction<boolean>>;
};

export const ConflictModal = ({
  setIsConflictModalOpen,
  isConflictModalOpen,
}: LinkAccountsModalProps) => {
  const { push } = useHistory(); 

  const toggleModal = () => setIsConflictModalOpen(!isConflictModalOpen);
  const handleBackToSignIn = () => {
    push({
      pathname: ROUTE_LOGIN,
    });
  };

  return (
    <Modal
      backgroundColor="#EDEDED"
      isOpen={isConflictModalOpen}
      onRequestClose={toggleModal}
    >
      <ConflictModalContent
        onCancelClick={toggleModal}
        onSignInClick={handleBackToSignIn}
      />
    </Modal>
  );
};
